import ThumnailVideoComponent from "../../../commons/components/Video/thumbnailVideo"

type Props = {
  videoDetail: Object,
  publishStatus: Boolean,
  params: Object
}

const Video = ({videoDetail, publishStatus, params }: Props) => {
  return(
    <div className="video-tab">
        <ThumnailVideoComponent videoDetail={videoDetail} location={params.type} publishStatus={publishStatus}/>
        <div className="album-page__notice-text d-flex align-items-center">
          <p className="album-page__notice-text-content">
            {videoDetail?.video_message?.title ?? ''}
          </p>
        </div>
      </div>
  )
}

Video.defaultProps = {
  src: '',
  title: 'title',
}
export default Video;